<ng-container>
  <br/>
  <div
    class="main-content"
    [ngClass]="{ 'create-login-actions': router.url === joint_account_create_login_path}">
    <button
      class="actions-btn primary-btn-action"
      [ngClass]="{'center-button' : router.url === create_invitation_path}"
      *ngIf="
        router.url === home_path ||
        router.url === joint_account_maintenance_path ||
        router.url === create_invitation_path ||
        router.url === joint_account_create_login_path ||
        router.url === create_login_path ||
        router.url === select_accounts_path ||
        router.url === fund_accounts
      "
      mat-flat-button
      color="primary"
      [class.spinner]="loading"
      [disabled]="getButtonDisabledState() | async"
      (click)="onClickOfContinue()"
      id="proceedToReviewAction"
    >
      continue
    </button>
    <button
      class="actions-btn primary-btn-action"
      [ngClass]="{'center-button': router.url === review_create_invitation_path}"
      #submitButton
      [hidden]="!isProceedButtonVisible()"
      mat-flat-button
      [class.spinner]="loading"
      [disabled]="getButtonDisabledState() | async"
      color="primary"
      (click)="onClickOfProceed()"
      id="submitAction"
    >
    <span *ngIf="router.url === terms_and_disclosures_path; else proceedText">Submit</span>
  <ng-template #proceedText>Proceed</ng-template>
    </button>
    <button
      class="width-full secondary-btn-action"
      *ngIf="isCancelButtonVisible()"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
      id="cancelAction"
    >
      Cancel
    </button>
  </div>
</ng-container>
